import { render, staticRenderFns } from "./InspectionsTableByVersionFilterModal.vue?vue&type=template&id=240fd1c4&scoped=true"
import script from "./InspectionsTableByVersionFilterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionsTableByVersionFilterModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionsTableByVersionFilterModal.vue?vue&type=style&index=0&id=240fd1c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240fd1c4",
  null
  
)

export default component.exports